module.exports = __webpack_public_path__ + "img/icon-limited.916b6653.svg";